import { SaveDialogContent, SaveButton } from "@/components/SaveForm";
import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Skeleton } from "@/components/ui/skeleton";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { CalendarClock, Plus, Trash2, Cog } from "lucide-react";

const inp = "bg-slate-950 border-slate-700 text-slate-100 mt-1";

export default function PlannedMachines() {
  const { can } = useAuth();
  const [list, setList] = useState(null);
  const [machines, setMachines] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ quantidade: 1 });

  const load = () => api.get("/planned-machines").then((r) => setList(r.data));
  useEffect(() => { load(); api.get("/machines").then((r) => setMachines(r.data)); }, []);

  const save = async () => {
    if (!form.modelo) { toast.error("Informe o modelo."); return; }
    try { await api.post("/planned-machines", { ...form, quantidade: Number(form.quantidade) || 1 }); toast.success("Máquina planejada cadastrada."); setOpen(false); setForm({ quantidade: 1 }); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => { try { await api.delete(`/planned-machines/${id}`); load(); } catch (e) { toast.error(apiErr(e)); } };

  if (list === null) return <Skeleton className="h-96 bg-slate-800" />;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-3">
        <div><h1 className="font-display text-3xl font-bold text-slate-50">Máquinas Planejadas</h1><p className="text-slate-400 text-sm">Expansão futura — o motor de reposição considera a demanda destas máquinas nas projeções.</p></div>
        {can("COMPRAS") && <Button data-testid="btn-new-planned" onClick={() => setOpen(true)} className="bg-sky-700 hover:bg-sky-600"><Plus className="h-4 w-4 mr-1" /> Nova máquina planejada</Button>}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((p) => (
          <Card key={p.id} className="card-metal p-5">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-2"><CalendarClock className="h-5 w-5 text-sky-400" /><h3 className="font-display text-lg font-semibold text-slate-100">{p.modelo}</h3></div>
              {can("COMPRAS") && <Button size="icon" variant="ghost" className="text-rose-400 h-7 w-7" onClick={() => del(p.id)}><Trash2 className="h-4 w-4" /></Button>}
            </div>
            <div className="mt-2 flex items-center gap-2"><span className="rounded-md bg-sky-950/50 border border-sky-800/50 px-2 py-0.5 text-sm font-bold text-sky-200">+{p.quantidade} unidade(s)</span><span className="text-xs text-slate-500">{p.tipo}</span></div>
            <div className="mt-3 text-sm text-slate-400 space-y-1">
              <div>Fornecedor: {p.fornecedor || "—"}</div>
              <div>Chegada prevista: {fmtDate(p.previsao_chegada)}</div>
              <div>Início operação: {fmtDate(p.previsao_inicio_operacao)}</div>
            </div>
            {p.observacoes && <div className="mt-2 text-xs text-slate-500">{p.observacoes}</div>}
          </Card>
        ))}
        {list.length === 0 && <p className="text-sm text-slate-500">Nenhuma máquina planejada.</p>}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <SaveDialogContent className="bg-slate-900 border-slate-700 text-slate-100">
          <DialogHeader><DialogTitle className="font-display text-2xl">Nova máquina planejada</DialogTitle></DialogHeader>
          <div className="grid sm:grid-cols-2 gap-3">
            <div className="sm:col-span-2"><Label>Máquina base (herda peças)</Label>
              <Select value={form.base_machine_id} onValueChange={(v) => { const mac = machines.find((x) => x.id === v); setForm({ ...form, base_machine_id: v, modelo: mac?.nome, tipo: mac?.tipo }); }}>
                <SelectTrigger className={inp}><SelectValue placeholder="Selecione a máquina base" /></SelectTrigger>
                <SelectContent className="bg-slate-900 border-slate-700 text-slate-100">{machines.map((m) => <SelectItem key={m.id} value={m.id}>{m.nome}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label>Modelo</Label><Input className={inp} value={form.modelo || ""} onChange={(e) => setForm({ ...form, modelo: e.target.value })} /></div>
            <div><Label>Quantidade</Label><Input type="number" className={inp} value={form.quantidade} onChange={(e) => setForm({ ...form, quantidade: e.target.value })} /></div>
            <div><Label>Fornecedor</Label><Input className={inp} onChange={(e) => setForm({ ...form, fornecedor: e.target.value })} /></div>
            <div><Label>Chegada prevista</Label><Input type="date" className={inp} onChange={(e) => setForm({ ...form, previsao_chegada: e.target.value ? new Date(e.target.value).toISOString() : "" })} /></div>
            <div><Label>Início operação</Label><Input type="date" className={inp} onChange={(e) => setForm({ ...form, previsao_inicio_operacao: e.target.value ? new Date(e.target.value).toISOString() : "" })} /></div>
          </div>
          <DialogFooter><Button variant="ghost" onClick={() => setOpen(false)}>Cancelar</Button><SaveButton onClick={save} className="bg-sky-700 hover:bg-sky-600">Salvar</SaveButton></DialogFooter>
        </SaveDialogContent>
      </Dialog>
    </div>
  );
}
